




































































































































/*message
adminResponse
    * */

    import {Vue, Component} from 'vue-property-decorator';
    import {CALENDAR_FORMAT, nil} from '@/common';
    import {Mixins} from 'vue-property-decorator';
    import GlobalAlertMixin from '@/mixins/GlobalAlertMixin.vue';
    import ImportDialog from '@/components/Views/Dashboard/Import & Export/ImportDialog.vue';
    import UserRoleMixin from '@/mixins/UserRoleMixin.vue';
    import ScreenSizeMixin from '@/mixins/ScreenSizeMixin.vue';
    import {DateTime} from 'luxon';
    import {pick} from 'lodash';
    import GenericDialog from '@/components/Views/UI/GenericDialog.vue';
import ValidationMixin from '@/mixins/ValidationMixin.vue';

    @Component({
        components: {
            GenericDialog,
            ImportDialog,
        },
    })
    export default class VendorSignUp extends Mixins(GlobalAlertMixin, UserRoleMixin, ScreenSizeMixin, ValidationMixin) {
        public defaultReference = {name: '', phoneNumber: ''};
        public defaultReferenceCount = 2;
        public references = [Object.assign({}, this.defaultReference), Object.assign({}, this.defaultReference)];
        public menuend = false;
        public menustart = false;
        public inputsValid = false;
        public headshotFile = null;
        public kitFile = null;
        public message = '';
        public adminResponse = null;
        public social = '';
        public hasTransportation = true;
        public notComfortableWith = [];
        public categoryApplyingFor = [];
        public servicesApplyingFor = [];
        public zip = '';
        public selectedTravelDistance = '';
        public languages = '';
        public howDidYouHearAboutUs = '';
        public interestInLessons = false;
        public previousJobTitle = '';
        public previousJobDescription = '';
        public previousJobStart = null;
        public hasLicense = true;
        public previousJobEnd = null;
        public licenseState = '';
        public firstName = '';
        public lastName = '';
        public email = '';
        public address = '';
        public address2 = '';
        public city = '';
        public state = '';
        public phone = '';
        public yearsOfExperience = null;
        public adminMode = false;
        public errorMessage = '';
        public maxWidth = 0;
        public showLightBox = false;
        public lightBoxImage = null;

        public categoryNames = [
            'Hair & Makeup',
            'Hair Styling',
            'Makeup Application',
        ];
        public serviceNames = [
            'Hair Styling',
            'Blow Outs',
            'Braided Styles',
            'Updos',
            'Clip-Ins',
            'Makeup Application',
            'Airbrush Makeup',
            'Airbrush Makeup with Lashes',
            'Makeup with Lashes',
            'Airbrush Tanning',
            'Waxing',
            'Massage',
            'Eyelash Extensions',
            'Esthetician',
            'Nails',
        ];
        public states = [
            'Alabama',
            'Alaska',
            'Arizona',
            'Arkansas',
            'California',
            'Colorado',
            'Connecticut',
            'Delaware',
            'Florida',
            'Georgia',
            'Hawaii',
            'Idaho',
            'Illinois',
            'Indiana',
            'Iowa',
            'Kansas',
            'Kentucky',
            'Louisiana',
            'Maine',
            'Maryland',
            'Massachusetts',
            'Michigan',
            'Minnesota',
            'Mississippi',
            'Missouri',
            'Montana',
            'Nebraska',
            'Nevada',
            'New Hampshire',
            'New Jersey',
            'New Mexico',
            'New York',
            'North Carolina',
            'North Dakota',
            'Ohio',
            'Oklahoma',
            'Oregon',
            'Pennsylvania',
            'Rhode Island',
            'South Carolina',
            'South Dakota',
            'Tennessee',
            'Texas',
            'Utah',
            'Vermont',
            'Virginia',
            'Washington',
            'West Virginia',
            'Wisconsin',
            'Wyoming',
            'Washington DC',
            'ARMED FORCES AFRICA \\ CANADA \\ EUROPE \\ MIDDLE EAST',
            'ARMED FORCES AMERICA (EXCEPT CANADA)',
            'ARMED FORCES PACIFIC',
        ];
        public desiredTravelDistance = [
            '30-60',
            '60-90',
            '90-120',
            '100-200',
            '200-300',
            '300+',
            'Any',
        ];
        public headshotImported(data) {
            this.headshotFile = data;
            (this.$refs.importHeadshot as any).open = false;
        }
        public kitImported(data) {
            this.kitFile = data;
            (this.$refs.importKit as any).open = false;
        }
        public getErrorMessage(include = []) {
            if (nil(this.$refs.form)) { return ''; }
            const errors = [...include, ...((this.$refs.form as any).inputs as any[]).map((x) => x.errorBucket).flat()];

            if (this.referencesOk !== true) { errors.push(this.referencesOk); }
            if (this.filesOk !== true) { errors.push(this.filesOk); }
            if (this.licenseOk !== true) { errors.push(this.licenseOk); }

            if (errors.length === 0) { return ''; }
            let message = errors.shift();

            if (errors.length >= 1) {
                message += ` and ${errors.length} other errors`;
            }
            return message;
        }
        public mounted() {
            if (this.userIsAdmin && this.$route.params.application) {
                this.adminMode = true;
                this.initWith(this.$route.params.application);
            }
        }
        public onHeadshotClick() {
            if (this.adminMode) {
                this.lightBoxImage = this.headshotFile.file;
                this.maxWidth = this.windowWidth() / 2;
                this.showLightBox = true;
            } else {
                (this.$refs.importHeadshot as any).open = true;
            }
        }
        public onKitClick() {
            if (this.adminMode) {
                this.lightBoxImage = this.kitFile.file;
                this.maxWidth = this.windowWidth() / 2;
                this.showLightBox = true;
            } else {
                (this.$refs.importKit as any).open = true;
            }
        }

        public async initWith(id) {
            try {
                const app = await this.$FeathersVuex.VendorApp.get(id);
                this.message = app.message;
                this.hasTransportation = app.hasTransportation;
                this.interestInLessons = app.interestInLessons;
                this.notComfortableWith = app.notComfortableWith;
                this.categoryApplyingFor = app.categoryApplyingFor;
                this.servicesApplyingFor = app.servicesApplyingFor;
                this.zip = app.zip;
                this.yearsOfExperience = app.yearsOfExperience;
                this.phone = app.phone;
                this.firstName = app.firstName;
                this.lastName = app.lastName;
                this.email = app.email;
                this.address = app.address;
                this.address2 = app.address2;
                this.city = app.city;
                this.state = app.state;
                this.languages = app.languages;
                this.headshotFile = app.headshotModel;
                this.kitFile = app.kitModel;
                this.selectedTravelDistance = app.selectedTravelDistance;
                this.howDidYouHearAboutUs = app.howDidYouHearAboutUs;
                this.previousJobTitle = app.previousJobTitle;
                this.previousJobDescription = app.previousJobDescription;
                this.licenseState = app.licenseState;
                this.hasLicense = app.hasLicense;
                this.previousJobStart = DateTime.fromISO(app.previousJobStart).toFormat(CALENDAR_FORMAT);
                this.previousJobEnd = DateTime.fromISO(app.previousJobEnd).toFormat(CALENDAR_FORMAT);
                this.references = app.references;
                console.log(app);
            } catch (e) {
                this.showAlert('Could not open application');
            }
        }

        public async attemptValidate() {
            if (this.formValid) {
                const {VendorApp} = this.$FeathersVuex;
                try {
                    const app = new VendorApp({
                        zip: this.zip,
                        yearsOfExperience: this.yearsOfExperience,
                        phone: this.phone,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        email: this.email,
                        address: this.address,
                        address2: this.address2,
                        city: this.city,
                        state: this.state,
                        languages: this.languages,
                        hasLicense: this.hasLicense,
                        headshot: this.headshotFile._id,
                        kitPicture: this.kitFile._id,
                        selectedTravelDistance: this.selectedTravelDistance,
                        howDidYouHearAboutUs: this.howDidYouHearAboutUs,
                        previousJobTitle: this.previousJobTitle,
                        previousJobDescription: this.previousJobDescription,
                        hasTransportation: this.hasTransportation,
                        interestInLessons: this.interestInLessons,
                        licenseState: this.licenseState,
                        notComfortableWith: this.notComfortableWith,
                        categoryApplyingFor: this.categoryApplyingFor,
                        servicesApplyingFor: this.servicesApplyingFor,
                        previousJobStart: this.previousJobStart,
                        previousJobEnd: this.previousJobEnd,
                        references: this.validReferences,
                    });
                    const a = await app.create();
                    this.showAlert(`Thanks, ${this.firstName}, your application has been submitted!`, 'success');
                    setTimeout(() => {
                        this.$router.replace('./');
                    }, 2500);
                } catch (e) {
                    console.log(e);
                    this.showAlert('We\'re sorry, there was a server error submitting your application!');
                }
            } else {
                this.errorMessage = this.getErrorMessage();
            }
        }

        public get referencesOk() {
            return this.validReferences.length > 0 || 'At least one reference is required';
        }
        public get filesOk() {
            const filesOk = !nil(this.headshotFile) && !nil(this.kitFile);
            return filesOk || 'Both Headshot and Kit Image are required';
        }
        public get licenseOk() {
            if (this.needsLicense) {
                return this.hasLicense || 'A Cosmetology License is required for your selected services';
            }
            return true;
        }
        public get validReferences() {
            return this.references.filter((x) => !nil(x.name, true) && !nil(x.phoneNumber, true));
        }
        public get formValid() {
            let refsOk = false;
            const checkrefs = this.referencesOk;
            if (checkrefs === true) {
                refsOk = true;
            }
            let filesOk = false;
            const checkFiles = this.filesOk;
            if (checkFiles === true) {
                filesOk = true;
            }
            let licenseOK = false;
            const checkLicense = this.licenseOk;
            if (checkLicense === true) {
                licenseOK = true;
            }

            return this.inputsValid && refsOk && filesOk && licenseOK;
        }
        public get needsLicense() {
            return this.categoryApplyingFor.join(',').toLowerCase().indexOf('hair') > -1;
        }
        public get hasResponse() {
            return !nil(this.adminResponse);
        }
        public get adminResponseTitle() {
            return this.adminResponse === null ? 'Accept or Reject this Pro' : this.adminResponse === true ? 'Pro was Accepted' : 'Pro was Rejected';
        }
    }
